var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"item__mark",style:({background: _vm.color})}),_c('div',{staticClass:"item__label"},[_vm._v(_vm._s(_vm.label)+"：")]),_c('div',{staticClass:"item__value"},[(!_vm.isLoading)?_c('marquee-text',{attrs:{"text":_vm.value}}):_c('span',{staticClass:"placeholder-value"},[_vm._v(_vm._s(_vm.value))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }